.m-toolbar-title {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &--shrink {
    flex: 0 0 auto;
    overflow: initial;
    text-overflow: initial;
    white-space: initial;
  }
}
